import { render, staticRenderFns } from "./AuthoritiesInput.vue?vue&type=template&id=12cd7036&scoped=true"
import script from "./AuthoritiesInput.vue?vue&type=script&lang=ts"
export * from "./AuthoritiesInput.vue?vue&type=script&lang=ts"
import style0 from "./AuthoritiesInput.vue?vue&type=style&index=0&id=12cd7036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cd7036",
  null
  
)

export default component.exports